/**
 * Routines to convert from generated types to friendlier ones.
 */

import {LaunchAgent} from '../../generated/graphql';
import {Agent, AgentStatus} from './utilTypes';

export const convertAgent = (agent: LaunchAgent): Agent => {
  const {
    id,
    name,
    createdAt,
    heartbeatAt,
    agentStatus,
    hostname,
    runQueues,
    stopPolling,
    agentConfig,
    version,
  } = agent;
  return {
    id,
    name,
    createdAt: createdAt.toString(),
    heartbeatAt: heartbeatAt?.toString() ?? null,
    agentStatus: agentStatus as AgentStatus,
    hostname,
    runQueues,
    stopPolling,
    config: agentConfig,
    version: version ?? null,
  };
};
